import ModalHeader from './container';

export default ModalHeader;
